module.exports = __webpack_public_path__ + "static/media/editProfile.738ec80c.svg";